import { createSlice } from "@reduxjs/toolkit";
import { isNil } from "ramda";
import { getAssetsData, getEquipments } from "../api";

const initialState = {
  data: null,
  loading: false,
  error: null,
};
const assetsSlice = createSlice({
  name: "ASSET",
  initialState,
  reducers: {
    getAssetsDataRequest: (state) => {
      state.data = null;
      state.loading = true;
      state.error = null;
    },
    getAssetsDataSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    getAssetsDataFailure: (state, action) => {
      state.data = null;
      state.loading = false;
      state.error = action.payload;
    },
    updateAllEquipments: (state, action) => {
      const incoming = Array.isArray(action.payload) ? action.payload : [];
      if (!state.data || incoming.length === 0) return;

      // Recorremos todos los assets
      state.data.forEach((asset) => {
        if (!Array.isArray(asset.equipments)) return;

        // Recorremos solo los equipos que corresponden a este asset
        incoming
          .filter((eq) => eq.asset === asset.name)
          .forEach((incomingEq) => {
            const idx = asset.equipments.findIndex((e) => e.equipmentID === incomingEq.equipmentID);
            if (idx !== -1) {
              // Actualiza los campos del equipo ya existente
              asset.equipments[idx] = {
                ...asset.equipments[idx],
                ...incomingEq,
              };
            }
          });
      });
    },
  },
});

export const { getAssetsDataRequest, getAssetsDataSuccess, getAssetsDataFailure, updateAllEquipments } =
  assetsSlice.actions;

export const getAssetsDataAction = (id) => {
  return async (dispatch) => {
    try {
      dispatch(getAssetsDataRequest());
      let response = await getAssetsData();
      if (!isNil(response?.status) && response?.status === 200 && !isNil(response.data)) {
        let payload = response.data.data;
        response = await getEquipments();
        if (!isNil(response?.status) && response?.status === 200 && !isNil(response.data)) {
          const equipments = response.data.data ?? [];
          payload = payload.map((a) => ({ ...a, equipments: equipments.filter((e) => e.asset === a.name) ?? [] }));
        }
        dispatch(getAssetsDataSuccess(payload));
        return;
      }
      dispatch(getAssetsDataFailure("Invalid response"));
    } catch (error) {
      dispatch(getAssetsDataFailure(error));
    }
  };
};

export const clearAssetsDataAction = () => {
  return async (dispatch) => {
    dispatch(getAssetsDataSuccess(null));
  };
};

export default assetsSlice.reducer;
